export const CURRENT_SAMPLE_MS = 30 * 60 * 1000;

// At each regular interval, use the nearest measurement within one interval.
// Shared by V1 and V2 so irregular samples and gaps produce the same arrows.
export function sampleCurrentDirections(points, intervalMs = CURRENT_SAMPLE_MS) {
  if (!Array.isArray(points) || points.length === 0) return [];
  const sorted = [...points].sort((a, b) => a.x - b.x);
  const min = sorted[0].x;
  const max = sorted[sorted.length - 1].x;
  const samples = [];
  for (let t = min; t <= max; t += intervalMs) {
    let nearest = null;
    let best = Infinity;
    for (const point of sorted) {
      const distance = Math.abs(point.x - t);
      if (distance < best) { best = distance; nearest = point; }
    }
    if (nearest && best <= intervalMs) {
      samples.push({ x: t, cd: nearest.cd, cs: nearest.cs });
    }
  }
  return samples;
}
